module.exports = __webpack_public_path__ + "img/ewm6.922f4a1b.jpg";